<template>
    <div class="l6bwb2e9">
        <div ref="light">
            <slot></slot>
        </div>
        <div
            v-if="status != 'normal'"
            class="l6bw5u3t"
            ref="shadow"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            status: "normal",
        };
    },
    methods: {
        // 计算是否有省略号
        hasEllipsis() {
            this.status = "calculating";
            return new Promise((resolve) => {
                this.$nextTick(() => {
                    this.status = "normal";
                    resolve(
                        this.$refs.shadow.offsetHeight -
                            this.$refs.light.offsetHeight >=
                            10
                    );
                });
            });
        },
    },
};
</script>

<style lang="less">
@import (reference) "@/assets/less/base.less";
.l6bwb2e9 {
    .pr;
}
.l6bw5u3t {
    .pa;
    .w;
    top: 0;
    left: 0;
    z-index: -1;
    > * {
        display: initial !important;
        white-space: normal !important;
    }
}
</style>